import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "socialbutton", "form", "option" ]

  connect() {
    this.formTarget.classList.add('unavailable')
    const selected = this.optionTargets.find((option) => option.checked)
    if (selected) this.change()
  }

  change() {
    this.formTarget.classList.remove('unavailable')
    this.socialbuttonTargets.forEach((socialbutton) => {
      socialbutton.href = socialbutton.href.replace(/\?referrer=.*/,'');
      socialbutton.href += "?referrer=" + this.selected.dataset.url;
    });
  }

  get selected() {
    return this.optionTargets.find((option) => option.checked)
  }
}
